export const CONFIG = {
  OKTA_DOMAIN: process.env.REACT_APP_OKTA_DOMAIN,
};
